import { createContext } from "react";

export const SchemeContext = createContext({});